// extracted by mini-css-extract-plugin
export var button = "_1k-0";
export var buttonContent = "_1k-e";
export var buttonGroup = "_1k-c";
export var dontRestrainIconWidth = "_1k-a";
export var dropdownButton = "_1k-b";
export var iconContainer = "_1k-9";
export var lg = "_1k-4";
export var md = "_1k-3";
export var pending = "_1k-f";
export var sm = "_1k-2";
export var spinner = "_1k-d";
export var squared = "_1k-8";
export var wrapText = "_1k-g";
export var xl = "_1k-5";
export var xs = "_1k-1";
export var xxl = "_1k-6";
export var xxxl = "_1k-7";